// extracted by mini-css-extract-plugin
module.exports = {"body":"TooltipVicri_body__2hjhe","icon":"TooltipVicri_icon__1xlo7"};